import ShortUniqueId from 'short-unique-id';

const dictionary = 'abcdefghijklmnopqrstuvwxyz1234567890'.split('');
const uuid = new ShortUniqueId({ dictionary });

export default uuid;
